import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import ServiceCard from "@/components/public/ServiceCard";
import CTASection from "@/components/public/CTASection";
import DevisForm from "@/components/public/DevisForm";
import SeoHead from "@/components/public/SeoHead";
import Breadcrumb from "@/components/public/Breadcrumb";
import FadeIn from "@/components/public/FadeIn";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ServicesListPage() {
  const [services, setServices] = useState([]);

  useEffect(() => {
    axios.get(`${API}/services`).then(r => setServices(r.data));
  }, []);

  const b2c = services.filter(s => s.type_client === "B2C" || s.type_client === "mixte");
  const b2b = services.filter(s => s.type_client === "B2B");

  return (
    <div data-testid="services-list-page">
      <SeoHead
        title="Services de nettoyage professionnel"
        description="Tous nos services de nettoyage en Suisse romande : canapés, matelas, moquettes, vitres, terrasses dès 125 CHF. Devis gratuit en 2h. 5★ Google."
        path="/services"
        breadcrumbs={[{ name: "Accueil", url: "/" }, { name: "Services" }]}
      />
      <Breadcrumb items={[{ name: "Accueil", url: "/" }, { name: "Services" }]} />
      {/* Hero */}
      <section className="bg-[#336DBF] py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-semibold text-white tracking-tight">
            Des solutions de nettoyage pour chaque besoin
          </h1>
          <p className="mt-4 text-white/80 text-lg max-w-2xl">
            Particuliers ou entreprises, nous avons le service adapté à votre situation. Devis gratuit et sans engagement.
          </p>
          <Link to="/contact" className="mt-6 inline-flex items-center justify-center px-8 py-3.5 bg-[#336DBF] text-white font-semibold rounded-md hover:bg-[#2A5A9E] transition-colors" data-testid="services-hero-cta">
            Devis gratuit
          </Link>
        </div>
      </section>

      {/* B2C Services */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#336DBF] mb-3">Particuliers</p>
            <h2 className="text-2xl sm:text-3xl font-semibold text-[#062133] tracking-tight">Services pour les particuliers</h2>
            <p className="mt-2 text-[#062133]/60">Nettoyage de canapé, matelas, moquette, terrasse, façade, toiture et plus encore.</p>
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
            {b2c.map(s => <ServiceCard key={s.slug} service={s} />)}
          </div>
        </div>
      </section>

      <CTASection title="Besoin d'un devis rapide ?" subtitle="Réponse garantie sous 2 heures. Sans engagement." />

      {/* B2B Services */}
      <section className="py-16 sm:py-24 bg-[#F4F6F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#336DBF] mb-3">Entreprises</p>
            <h2 className="text-2xl sm:text-3xl font-semibold text-[#062133] tracking-tight">Services pour les entreprises</h2>
            <p className="mt-2 text-[#062133]/60">Bureaux, hôtels, régies immobilières, cinémas — des solutions sur mesure.</p>
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
            {b2b.map(s => <ServiceCard key={s.slug} service={s} />)}
          </div>
          <div className="mt-8">
            <Link to="/contrats-entreprises" className="inline-flex items-center gap-2 text-[#336DBF] font-semibold hover:underline">
              Découvrir nos contrats entreprises &rarr;
            </Link>
          </div>
        </div>
      </section>

      {/* Devis */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <div className="text-center mb-8">
              <h2 className="text-2xl sm:text-3xl font-semibold text-[#062133] tracking-tight">Demandez votre devis</h2>
              <p className="mt-2 text-[#062133]/60">Gratuit et sans engagement</p>
            </div>
            <div className="bg-white border border-[#062133]/10 rounded-lg p-6 sm:p-8 shadow-sm">
              <DevisForm source="direct" />
            </div>
          </FadeIn>
        </div>
      </section>
    </div>
  );
}
